const minBy = (arr, fn) => arr.reduce((min, item) => (fn(item) < fn(min) ? item : min))

/**
 * Marks the cheapest itinerary (or itineraries) in a listings array by setting
 * the `isCheapest` flag on each item.
 *
 * When `cheapestPrice` is provided (e.g. carried over from a previous slice
 * selection), it is used directly as the reference price. Otherwise the
 * cheapest price is derived from the listings themselves via `price[1].amount`.
 *
 * @param {Object[]} listings - Array of flight itinerary objects.
 * @param {number} [cheapestPrice] - Optional price override to use as the
 *   cheapest-price reference. When omitted or `undefined`, the minimum price is
 *   derived from the `listings` array. Pass a value to keep the cheapest marker
 *   consistent across filter / slice updates.
 * @returns {Object[]} A new array where each itinerary has an `isCheapest`
 *   boolean property. Returns the original `listings` reference unchanged when
 *   it is falsy or empty.
 */
export const setCheapestItinerary = (listings, cheapestPrice) => {
  if (!listings || listings.length === 0) return listings

  const cheapestItin = cheapestPrice ?? minBy(listings, (i) => i.price?.[1]?.amount)?.price?.[1]?.amount
  return listings.map((i) => ({
    ...i,
    isCheapest: i?.price?.[1]?.amount === cheapestItin,
  }))
}
